const home = {
    data: () => ({
        cards: [],
        imgsCarousel: [],
        leaders: [],
        loading: false
    }),
    mounted() {
        this.fetchImgsCarousel();
        this.fetchTarjetas();
        this.fetchLeaders();
    },
    methods: {
        async fetchTarjetas() {
            try {
                const response = await this.$axios.get('getCard');
                const data = response.data[0]["fn_sic_obtener_tarjetas"];

                // Dividir los datos en tarjetas individuales
                const tarjetasArray = data.split('‡');

                // Procesar cada tarjeta y convertirla en un objeto
                this.cards = tarjetasArray.map(tarjeta => {
                    const [
                        titulo,
                        description,
                        useBullets,
                        bullets,
                        bulletType,
                        showCard,
                        showImage,
                        imageUrl,
                        imagePosition,
                        backgroundColor,
                        backgroundImageUrl,
                        fontSize,
                        fontColor
                    ] = tarjeta.split('†');


                    return {
                        titulo,
                        description,
                        useBullets: useBullets === 'true',
                        bullets: bullets.search(',') ? bullets.split(',') : bullets,
                        bulletType,
                        showCard: showCard === 'true',
                        showImage: showImage === 'true',
                        imageUrl,
                        imagePosition,
                        backgroundColor,
                        backgroundImageUrl,
                        fontSize,
                        fontColor
                    };
                });
            } catch (error) {
                console.error('Error al guardar los eventos:', error);
            }
        },
        getCardStyle(tarjeta) {
            let style = {};
            if (tarjeta.backgroundColor) {
                style.backgroundColor = tarjeta.backgroundColor;
            }
            if (tarjeta.backgroundImageUrl) {
                style.backgroundImage = `url(${tarjeta.backgroundImageUrl})`;
                style.backgroundSize = 'cover';
                style.backgroundPosition = 'center';
            }
            return style;
        },
        textStyle(tarjeta) {
            return {
                fontSize: tarjeta.fontSize,
                color: tarjeta.fontColor,
                lineHeight: '1.5' // Ajusta el valor según sea necesario
            };
        },
        async fetchLeaders() {
            try {
                const response = await this.$axios.get('getLeader');
                this.leaders = response.data.filtered;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async fetchImgsCarousel() {
            try {
                const response = await this.$axios.get('getImgsCarousel');
                this.imgsCarousel = response.data.files;
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            }
        }
    }
}
export default home